import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPostidentStepOne = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 43,
	viewBox: "0 0 100 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 1,
			width: 41,
			height: 35,
			rx: 3,
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 31H52V33C52 34.6569 50.6569 36 49 36H4C2.34315 36 1 34.6569 1 33V31Z",
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 64,
			y: 8,
			width: 28,
			height: 7,
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 70,
			y: 1,
			width: 16,
			height: 14,
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 58,
			y: 15,
			width: 41,
			height: 19,
			rx: 3,
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 68,
			y: 29,
			width: 20,
			height: 13,
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72,
			y1: 38.5,
			x2: 84,
			y2: 38.5,
			stroke: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72,
			y1: 35.5,
			x2: 84,
			y2: 35.5,
			stroke: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 72,
			y1: 32.5,
			x2: 84,
			y2: 32.5,
			stroke: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 62,
			cy: 19,
			r: 1,
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 65,
			cy: 19,
			r: 1,
			fill: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 68,
			cy: 19,
			r: 1,
			fill: "#4EA699"
		})
	]
});
const ForwardRef = forwardRef(SvgPostidentStepOne);
export { ForwardRef as ReactComponent };
